module.exports = "<div class=\"dialog-header\">\n    <h3 class=\"cerba-h3\">{{title | translate}}</h3>\n</div>\n<div class=\"dialog-content\">\n  <p>{{question | translate}}</p>\n</div>\n\n<div class=\"dialog-action\">\n    <button type=\"button\" class=\"cerba\" (click)=\"dialog.close()\">{{confirmButton | translate}}</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/modal/info/info.modal.html
// module id = ../../../../../../../../../../digicerba-common-module/src/components/modal/info/info.modal.html
// module chunks = 1